/**
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import { map, find } from 'lodash';

import { updateLocale } from '../../actions/intl';
import Language from '../components/Language';

const intlMessages = defineMessages({
    en: {
        id: 'layout.salon.Language.en',
        defaultMessage: 'English',
    },
    lv: {
        id: 'layout.salon.Language.lv',
        defaultMessage: 'Latvian',
    },
    ru: {
        id: 'layout.salon.Language.ru',
        defaultMessage: 'Russian',
    },
});

const languages = [
    {
        locale: 'en',
        name: 'English',
        flag: 'us',
    },
    {
        locale: 'lv',
        name: 'Latvian',
        flag: 'lv',
    },
    {
        locale: 'ru',
        name: 'Russian',
        flag: 'ru',
    },
];

function LanguageContainer(props) {
    const { currentLocale, intl } = props;
    const currentLanguage = find(languages, { locale: currentLocale });

    // Provide current language
    const language = {
        ...currentLanguage,
        name: intl.formatMessage(intlMessages[currentLanguage.locale]),
    };
    // Map list of languages to options for dropdown menu
    const options = map(languages, lang => ({
        flag: lang.flag,
        value: lang.locale,
        text: intl.formatMessage(intlMessages[lang.locale]),
    }));

    return <Language {...props} language={language} options={options} />;
}

const mapStateToProps = ({ intl }) => ({
    currentLocale: intl.get('locale'),
});

export default connect(
    mapStateToProps,
    { onChange: updateLocale },
)(injectIntl(LanguageContainer));
